import React from 'react';
import { useWindowWidth } from '../../../helpers/useWindowWidth';
import { ReactComponent as AnimationIcon1 } from '../../../assets/img/natemat/tip/tipanimation1.svg?react';
import { ReactComponent as AnimationIcon2 } from '../../../assets/img/natemat/tip/tipanimation2.svg?react';
import { useScroll, animated } from '@react-spring/web';
import { styled } from "../../../stitches.config";

const TipAnimation = () => {

    const isDesktop = useWindowWidth() > 992;

    const { scrollYProgress } = useScroll();

    return (
        <TextAnimation>
            <animated.div
                className='div1'
                style={{
                    position: 'absolute',
                    left: scrollYProgress.to(scrollP => {
                        if (isDesktop ? scrollP < 0.09 : scrollP < 0.05)
                            return isDesktop ? scrollP * 4400 - 400 : scrollP * 1000 - 50;
                        else
                            return isDesktop ? 0.09 * 4400 - 400 : 0.05 * 1000 - 50;
                    })
                }}>
                <AnimationIcon1 />
            </animated.div >
            <animated.div
                className='div2'
                style={{
                    position: 'absolute',
                    right: scrollYProgress.to(scrollP => {
                        if (isDesktop ? scrollP < 0.09 : scrollP < 0.05)
                            return isDesktop ? scrollP * 4400 - 400 : scrollP * 1000 - 50;
                        else
                            return isDesktop ? 0.09 * 4400 - 400 : 0.05 * 1000 - 50;
                    })
                }}>
                <AnimationIcon2 />
            </animated.div >
        </TextAnimation>
    )
}

export default TipAnimation;

const TextAnimation = styled('div', {
    height: '250px',
    position: 'relative',
    svg: {
        height: '54px',
        width: 'fit-content',
    },
    '.div1': {
        top: '100px',
    },
    '.div2': {
        top: '200px',
    },
    '@bp4': {
        height: '500px',
        svg: {
            height: '168px',
            width: 'fit-content',
        },
        '.div1': {
            top: '100px',
        },
        '.div2': {
            top: '300px',
        },
    }
})